<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-6">
						<h4 class="card-title">
							<i class="material-icons" (click)="back()">arrow_left</i>
							Customer Export
						</h4>
					</div>

					<div class="card-body">
						<div class="m-auto main-width">



							<div class="filter-panel">
								<form [formGroup]="searchForm">
									<div class="row">

										<!-- Date Range -->
										<div class="col-md-3 mt-3">
											<label class="form-label fw-bold">Transaction Dates</label>
											<mat-form-field appearance="outline">
												<mat-date-range-input [rangePicker]="picker">
													<input matStartDate formControlName="fromDateCtrl" placeholder="Start Date" />
													<input matEndDate formControlName="toDateCtrl" placeholder="End Date" />
												</mat-date-range-input>
												<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
												<mat-date-range-picker #picker></mat-date-range-picker>
											</mat-form-field>
										</div>

										<!-- Keyword -->
										<div class="col-md-3 mt-3">
											<label class="form-label fw-bold">Keyword</label>
											<mat-form-field appearance="outline" class="w-100">
												<input
												  matInput
												  formControlName="keywords"
												  placeholder="Customer Name / Ref"
												  autocomplete="off"
												  (keydown.enter)="getCustExport()"
												/>
											</mat-form-field>
										</div>

										<!-- City -->
										<div class="col-md-3 mt-3">
											<label class="form-label fw-bold">City</label>
											<mat-form-field appearance="outline" class="w-100">
												<input matInput [formControl]="cityCtrl" [matAutocomplete]="autoCity" placeholder="Type to search..." />
												<mat-autocomplete #autoCity="matAutocomplete" (optionSelected)="selectCity($event.option.value)">
													<mat-option *ngFor="let c of filteredCities | async" [value]="c">
														{{ c.city }}
													</mat-option>
												</mat-autocomplete>
											</mat-form-field>
											<div class="chip-list">
												<span class="chip" *ngFor="let city of selectedCities" (click)="selectedCities = removeValue(selectedCities, city, 'city')">
													{{ city.city }} ✕
												</span>
												<span *ngIf="selectedCities.length" class="chip clear" (click)="clearCities()">Clear</span>
											</div>
										</div>

										<!-- Region -->
										<div class="col-md-3 mt-3">
											<label class="form-label fw-bold">Region</label>
											<mat-form-field appearance="outline" class="w-100">
												<input matInput [formControl]="stateCtrl" [matAutocomplete]="autoState" placeholder="Type to search..." />
												<mat-autocomplete #autoState="matAutocomplete" (optionSelected)="selectState($event.option.value)">
													<mat-option *ngFor="let s of filteredStates | async" [value]="s">
														{{ s.statecode }} - {{ s.statename }}
													</mat-option>
												</mat-autocomplete>
											</mat-form-field>
											<div class="chip-list">
												<span class="chip" *ngFor="let state of selectedStates" (click)="selectedStates = removeValue(selectedStates, state, 'statecode')">
													{{ state.statecode }} ✕
												</span>
												<span *ngIf="selectedStates.length" class="chip clear" (click)="clearStates()">Clear</span>
											</div>
										</div>

										<!-- Salesperson -->
										<div class="col-md-3 mt-3">
											<label class="form-label fw-bold">Salesperson</label>
											<mat-form-field appearance="outline" class="w-100">
												<input matInput [formControl]="salespersonCtrl" [matAutocomplete]="autoSalesperson" placeholder="Type to search..." />
												<mat-autocomplete #autoSalesperson="matAutocomplete" (optionSelected)="selectSalesperson($event.option.value)">
													<mat-option *ngFor="let sp of filteredSalespeople | async" [value]="sp">
														{{ sp.salesmanname }}
													</mat-option>
												</mat-autocomplete>
											</mat-form-field>
											<div class="chip-list">
												<span class="chip" *ngFor="let sp of selectedSalespeople" (click)="selectedSalespeople = removeValue(selectedSalespeople, sp, 'salesmancode')">
													{{ sp.salesmanname }} ✕
												</span>
												<span *ngIf="selectedSalespeople.length" class="chip clear" (click)="clearSalespeople()">Clear</span>
											</div>
										</div>

										<!-- Product Line -->
										<div class="col-md-3 mt-3">
											<label class="form-label fw-bold">Product Line</label>
											<mat-form-field appearance="outline" class="w-100">
												<input matInput [formControl]="prodlineCtrl" [matAutocomplete]="autoProdLine" placeholder="Type to search..." />
												<mat-autocomplete #autoProdLine="matAutocomplete" (optionSelected)="selectProductLine($event.option.value)">
													<mat-option *ngFor="let pl of filteredProductLines | async" [value]="pl">
														{{ pl.line_field }} - {{ pl.line_description }}
													</mat-option>
												</mat-autocomplete>
											</mat-form-field>
											<div class="chip-list">
												<span class="chip" *ngFor="let line of selectedProductLines" (click)="selectedProductLines = removeValue(selectedProductLines, line, 'line_field')">
													{{ line.line_field }} ✕
												</span>
												<span *ngIf="selectedProductLines.length" class="chip clear" (click)="clearProductLines()">Clear</span>
											</div>
										</div>

										<!-- Toggle Advanced Filters -->
										<div class="col-md-12 mt-3">
											<button mat-stroked-button color="accent" type="button" (click)="showAdvanced = !showAdvanced">
												{{ showAdvanced ? 'Hide Advanced Filters' : 'Show Advanced Filters' }}
											</button>
										</div>

										<!-- Advanced Filters -->
										<div class="col-md-12 mt-3" *ngIf="showAdvanced">
											<div class="row">
												<div class="col-md-3 mt-3" *ngFor="let f of [
					   { label: 'Sales Floor', field: 'salesfloor', type: 'text' },
					   { label: 'Client Since', field: 'clientsince', type: 'date' },
					   { label: 'Balance Due', field: 'balancedue', type: 'select', options: [{ label: 'No', value: '0' }, { label: 'Yes', value: '1' }] },
					   { label: 'Mising Email', field: 'emailflag', type: 'select', options: [{ label: 'No', value: '0' }, { label: 'Yes', value: '1' }] }
					 ]">
													<label class="form-label fw-bold">{{ f.label }}</label>

													<!-- Date -->
													<mat-form-field *ngIf="f.type === 'date'" appearance="outline" class="w-100">
														<input matInput [formControlName]="f.field" [matDatepicker]="picker" />
														<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
														<mat-datepicker #picker></mat-datepicker>
													</mat-form-field>

													<!-- Text -->
													<mat-form-field *ngIf="f.type === 'text'" appearance="outline" class="w-100">
														<input matInput [formControlName]="f.field" />
													</mat-form-field>

													<!-- Select -->
													<mat-form-field *ngIf="f.type === 'select'" appearance="outline" class="w-100">
														<mat-select [formControlName]="f.field">
															<mat-option *ngFor="let opt of f.options" [value]="opt.value">{{ opt.label }}</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
											</div>
										</div>

										<!-- Action Buttons -->
										<div class="col-md-8 mt-4 text-end">
											<mat-spinner *ngIf="sending" diameter="20" class="me-2"></mat-spinner>
										  <button mat-raised-button color="primary" type="button"  (click)="getCustExport()">

											{{ sending ? 'Running...' : 'Run' }}
										  </button>
										</div>

										<div class="col-md-4 mt-4 text-right">
											<ng-container  *ngIf="displayedRows?.length > 0">
												<button class="btn btn-sm btn-success" (click)="exportXls()" matTooltip="Export XLSX">
													<i class="fa fa-file-excel-o"></i>
												</button>

												<button class="btn btn-sm btn-danger" (click)="exportPdf()" matTooltip="Export PDF">
													<i class="fa fa-file-pdf-o"></i>
												</button>
											</ng-container>
										</div>
									</div>
								</form>
							</div>

							<!-- Report Results Table -->
							<ng-container *ngIf="orderResults">
								<hr />
								<h3>
									Customer Listing
									{{ searchForm.get('fromDateCtrl').value | date: 'MM/d/yy' }} -
									{{ searchForm.get('toDateCtrl').value | date: 'MM/d/yy' }}
								</h3>
								<h4>{{ orderResults.title }}</h4>


								<div class="d-flex justify-content-end mb-2">
									<!-- Updated Paginator Binding -->
									<mat-paginator [length]="orderResults?.values?.length || 0" [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault" showFirstLastButtons (page)="updateDisplayedRows()"></mat-paginator>
								</div>

								<div class="table-responsive">
									<table class="table table-bordered table-striped table-hover table-sm">
										<thead class="thead-dark text-nowrap">
											<tr>
												<th>Number</th>
												<th>Type</th>
												<th>Customer</th>
												<th>Branch</th>
												<th>Address</th>
												<th>Address 2</th>
												<th>City</th>
                                                <th>Region</th>
												<th>Zip</th>
												<th>Contact</th>
												<th>Phone</th>
												<th>Email</th>
												<th>Ship Method</th>
												<th class="text-end">Current</th>
												<th class="text-end">Over 30</th>
												<th class="text-end">Over 60</th>
												<th class="text-end">Over 90</th>
												<th>Club</th>
												<th>Client Since</th>
												<th class="text-end">Total Sales</th>
												<th>Payment Terms</th>
											    <th>Notes</th>
												<th>A/R Interest Rate</th>
												<th>Username</th>
												<th>Groups</th>
												<th>Salon Alliance Id</th>
											</tr>
										</thead>
										<tbody>
											<ng-container *ngFor="let o of displayedRows">
											  <tr>
												<td [innerHTML]="o.debtorno + '.' + o.branchcode"></td>
												<td [innerHTML]="o.typename"></td>
												<td [innerHTML]="o.name"></td>
												<td [innerHTML]="o.brname"></td>
												<td [innerHTML]="o.billing_address1"></td>
												<td [innerHTML]="o.billing_address2"></td>
												<td [innerHTML]="o.billing_address3"></td>
												<td [innerHTML]="o.billing_address4"></td>
												<td [innerHTML]="o.billing_address5"></td>
												<td [innerHTML]="o.contactname"></td>
												<td [innerHTML]="o.phoneno"></td>
												<td [innerHTML]="o.email"></td>
												<td [innerHTML]="o.shipping_method"></td>
												<td class="text-end" [innerHTML]="o.current | currency"></td>
												<td class="text-end" [innerHTML]="o.due | currency"></td>
												<td class="text-end" [innerHTML]="o.overdue1 | currency"></td>
												<td class="text-end" [innerHTML]="o.overdue2 | currency"></td>
												<td [innerHTML]="o.club"></td>
												<td [innerHTML]="o.clientsince | date: 'MM/d/yy'"></td>
												<td class="text-end" [innerHTML]="o.total | currency"></td>
												<td [innerHTML]="o.paymentterms"></td>
												<td [innerHTML]="o.notes"></td>
												<td [innerHTML]="o.arintrate"></td>
												<td [innerHTML]="o.username"></td>
												<td [innerHTML]="o.group"></td>
												<td [innerHTML]="o.salonallianceid"></td>
											  </tr>
											</ng-container>
										</tbody>
									</table>
								</div>
							</ng-container>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>